import {
  Transforms,
  Node,
  Path
} from 'slate';

import * as serializer from 'basic-editor-value-serializer';

import HelptapEditor from '../../helpers';

function withSchema(editor) {
  const { normalizeNode } = editor;

  editor.normalizeNode = entry => {
    const [node, path] = entry;

    // Rule for 'columns' node: Only allow 'column' children
    if (node.type === 'columns') {

      if (path.length === 1) {
        const nextNodePath = Path.next(path);

        if (Node.has(editor, nextNodePath) === false) {
          const defaultNode = HelptapEditor.paragraph.buildNode();
          Transforms.insertNodes(editor, defaultNode, { at: nextNodePath });
        }
      }

      for (const [child, childPath] of Node.children(editor, path)) {
        if (child.type !== 'column') {
          // Remove the invalid child node
          Transforms.removeNodes(editor, { at: childPath });
          return;
        }
      }
    }

    // Rule for 'column' node: Disallow 'column' children
    if (node.type === 'column') {
      for (const [child, childPath] of Node.children(editor, path)) {
        if (child.type === 'column') {
          // Remove the invalid child node
          Transforms.removeNodes(editor, { at: childPath });
          return;
        }
        // if (child.type === 'columns') {
        //   // Remove the invalid child node
        //   Transforms.removeNodes(editor, { at: childPath });
        //   return;
        // }
        if (serializer.allTypes.topLevelElements.includes(child.type) === false) {
          Transforms.removeNodes(editor, { at: childPath });
          return;
        }
      }
    }

    // If no schema violations, continue with the next normalization rule
    normalizeNode(entry);
  };

  return editor;
};

export default withSchema;